<template>
  <div class="container">
    <div class="tabBox">
      <div :class="status == 76 ? 'active' : ''" @click="typeClick(76)">
        活动推广
      </div>
      <div :class="status == 77 ? 'active' : ''" @click="typeClick(77)">
        网络推广
      </div>
      <div :class="status == 78 ? 'active' : ''" @click="typeClick(78)">
        其他推广
      </div>
    </div>
    <div class="bigBox">
      <div class="title">2023阿拉丁神灯奖</div>
      <div v-if="list.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="getListHandle"
          class="allBox"
        >
          <div
            class="itemBox"
            v-for="(item, index) in list"
            :key="index"
            @click.stop="toDetailHandle(item.Url)"
          >
            <van-image :src="item.ImgUrl" class="img" fit="cover" />
            <div class="desc overFlowTwo">{{ item.Title }}</div>
          </div>
        </van-list>
      </div>
      <div class="noDataBox" v-if="list.length == 0">
        <div class="kongIcon"><text class="iconfont icon-kong"></text></div>
        <div>暂无推广内容！</div>
      </div>
    </div>
  </div>
</template>
<script>
import { List, Image } from "vant";
import { propagateList } from "@/api/lighting";
export default {
  name: "promotion",
  components: {
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      status: 76,

      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
    };
  },
  methods: {
    toDetailHandle(href) {
      window.location.href = href;
    },
    typeClick(n) {
      this.pageIndex = 1;
      this.list = [];
      this.status = n;
      this.getListHandle();
    },

    //获取列表
    getListHandle() {
      var that = this;
      var data = {
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        AwardYear: that.awardYear,
        CategoryId: Number(that.status),
      };
      propagateList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          } else if (that.list.length < 10) {
            that.finished = true;
          } else {
            that.finished = false;
          }
        })
        .catch(() => {
          that.error = true;
        });
    },
  },
  mounted() {
    this.pageIndex = 1;
    this.list = [];
    this.getListHandle();
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background-color: #f0f0f4;
}

.noDataBox .icon-kong {
  color: #dddddd;
}

.tabBox {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 52px;
  font-size: 13px;
  color: #333;
  background-color: #fff;
  position: fixed;
  width: 100%;
  z-index: 2;
}

.tabBox > div.active {
  color: #3e69af;
  font-weight: bold;
  position: relative;
}

.tabBox > div.active::before {
  content: "";
  display: block;
  position: absolute;
  top: 22px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 30px;
  height: 5px;
  background: #3e69af;
  border-radius: 3px;
}

.bigBox {
  padding: 62px 12px;
  box-sizing: border-box;
}

.title {
  color: #000733;
  font-size: 15px;
  font-weight: bold;
  position: relative;
  margin-left: 7px;
  margin-bottom: 14px;
}

.title::before {
  content: "";
  display: block;
  width: 4px;
  height: 15px;
  background: #9699a9;
  border-radius: 2px;
  position: absolute;
  top: 4px;
  left: -7px;
}

.allBox {
  display: flex;
  flex-wrap: wrap;
}

.itemBox {
  width: 170px;
  margin-right: 10px;
  margin-bottom: 17px;
}

.itemBox:nth-child(2n) {
  margin-right: 0px;
}

.container >>> .van-image__img {
  display: block;
  width: 170px;
  height: 128px;
  border-radius: 5px;
}

.desc {
  color: #000733;
  font-size: 12px;
  font-weight: 400;
}
</style>